import { render, staticRenderFns } from "./registrationClosedDialog.vue?vue&type=template&id=08aeb6dc"
import script from "./registrationClosedDialog.vue?vue&type=script&lang=js"
export * from "./registrationClosedDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports